




































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel'
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import DateTimeUtils from '@/lib/dateTimeUtils';
import CurrencyUtils from '@/lib/currencyUtils';
import LocationDto from '@/models/Locations/LocationDto';
import BranchDto from '@/models/Branches/BranchDto';
import DepartmentDto from '@/models/Departments/DepartmentDto';
import { WorkerWizardModule } from '@/store/modules/workerWizard';
import WorkerAvailabilityDetails from '@/components/Workers/WorkerAvailabilityDetails.vue';
import IWorkerAvailability from '@/models/Workers/IWorkerAvailability';
import WorkType from '@/models/Shared/WorkType';

@Component({
  name: 'WorkerWizardReview',
  components: { WorkerAvailabilityDetails }
})
export default class WorkerWizardReview extends Vue {

    get currentStep() {
        return BookingWizardModule.newBooking.currentStep;
    }

    get worker() {
        return WorkerWizardModule.newWorker.worker;
    }

    get workerVM() {
        return WorkerWizardModule.newWorker;
    }

    get workerAsInterface() {
        return WorkerWizardModule.newWorker.worker as IWorkerAvailability
    }

    get isTempSelected() {
        return this.worker.workTypes && this.worker.workTypes.includes(WorkType.Temp);
    }

    get isPermSelected() {
        return this.worker.workTypes && this.worker.workTypes.includes(WorkType.Perm);
    }

    get isMergeMode() {
        return !!WorkerWizardModule.selectedDuplicateMatch;
    }

    get defaultBranchName() {
        return this.workerVM.defaultBranch ? this.workerVM.defaultBranch.name : '-';
    }

    get defaultDeskName() {
        return this.workerVM.defaultDesk ? this.workerVM.defaultDesk.name : '-';
    }

    get existingWorkerName() {
        const match = WorkerWizardModule.selectedDuplicateMatch;
        if (!match) return '';
        const worker = match.worker as any;
        const firstName = worker.person ? worker.person.firstName : '';
        const lastName = worker.person ? worker.person.lastName : '';
        return `${firstName} ${lastName}`.trim() || 'Unknown';
    }

    get existingWorkerRef() {
        const match = WorkerWizardModule.selectedDuplicateMatch;
        return match ? match.worker.sequenceNumber : '';
    }

    get hasCoordinates(): boolean {
        return this.worker.geometry && (this.worker.geometry.lat !== 0 || this.worker.geometry.lng !== 0);
    }

    get mapCenter() {
        return {
            lat: Number(this.worker.geometry?.lat) || 0,
            lng: Number(this.worker.geometry?.lng) || 0
        };
    }
}
